export default {
  'pages.layouts.userLayout.title':
    'AI Dovut — проект JURAT, ориентированный на анализ и генерацию контента',
  'pages.login.accountLogin.tab': 'Вход в аккаунт',
  'pages.login.tab.login': 'Вход',
  'pages.login.accountLogin.errorMessage': 'Неверный логин/пароль(admin@gmail.com/ant.design)',
  'pages.login.failure': 'Ошибка входа, попробуйте снова!',
  'pages.login.success': 'Вход выполнен успешно!',
  'pages.login.login.label': 'Логин',
  'pages.login.login.placeholder': 'Введите ваш логин',
  'pages.login.login.required': 'Пожалуйста, введите ваш логин!',
  'pages.login.login.invalid': 'Неверный формат логина!',
  'pages.login.password.label': 'Пароль',
  'pages.login.password.placeholder': 'Введите пароль',
  'pages.login.password.required': 'Пожалуйста, введите ваш пароль!',
  'pages.login.password.min': 'Пароль должен содержать минимум 6 символов',
  'pages.login.password.max': 'Пароль не может превышать 20 символов',
  'pages.login.captcha.placeholder': 'Код подтверждения',
  'pages.login.captcha.required': 'Пожалуйста, введите код подтверждения!',
  'pages.getCaptchaSecondText': 'сек',
  'pages.login.rememberMe': 'Запомнить меня',
  'pages.login.forgotPassword': 'Забыли пароль?',
  'pages.login.submit': 'Войти',
  'pages.login.loginWith': 'Войти через:',
  'pages.login.registerAccount': 'Зарегистрировать аккаунт',
  'pages.welcome.alertMessage': 'Выпущены более быстрые и мощные тяжелые компоненты.',
  'pages.404.subTitle': 'Извините, страница, которую вы посетили, не существует.',
  'pages.404.buttonText': 'Вернуться домой',
  //signup
  'pages.signup.tab': 'Регистрация',
  'pages.signup.login.placeholder': 'Введите ваш логин',
  'pages.signup.login.required': 'Пожалуйста, введите ваш логин!',
  'pages.signup.login.invalid': 'Неверный формат логина!',
  'pages.signup.name.label': 'Имя',
  'pages.signup.name.placeholder': 'Как Вас зовут?',
  'pages.signup.name.required': 'Пожалуйста, введите ваше имя!',
  'pages.signup.name.max': 'Имя не может превышать 50 символов',
  'pages.signup.password.placeholder': 'Введите пароль',
  'pages.signup.password.required': 'Пожалуйста, введите ваш пароль!',
  'pages.signup.password.min': 'Пароль должен содержать минимум 6 символов',
  'pages.signup.password.max': 'Пароль не может превышать 20 символов',
  'pages.signup.confirmPassword.label': 'Повторите пароль',
  'pages.signup.confirmPassword.placeholder': 'Введите пароль',
  'pages.signup.confirmPassword.required': 'Пожалуйста, повторите пароль!',
  'pages.signup.confirmPassword.mismatch': 'Пароли не совпадают!',
  'pages.signup.submit': 'Зарегистрироваться',
  'pages.signup.success': 'Регистрация прошла успешно!',
  'pages.signup.failure': 'Ошибка регистрации, попробуйте снова!',
  // Welcome page
  'pages.monitoring.communications': 'Поиск коммуникаций',
  'pages.monitoring.communicationDetails': 'Данные коммуникаций',
  'pages.monitoring.focus': 'Открыто из статистики: {user}',
  'pages.welcome.stats.title': 'Статистика чата',
  'pages.welcome.stats.users': 'Пользователи чата',
  'pages.welcome.stats.avgResponse': 'Среднее время отклика',
  'pages.welcome.stats.textRequests': 'Текстовые запросы',
  'pages.welcome.stats.voiceRequests': 'Голосовые запросы',
  'pages.welcome.stats.dynamics': 'Запросы по дням',
  'pages.welcome.stats.tooltip': 'текст {text}, голос {voice}',
  'pages.welcome.stats.period': 'Период: {from} — {to}',
  'pages.welcome.stats.loadError': 'Не удалось загрузить статистику чата',
  'pages.welcome.stats.seconds': 'с',
  'pages.welcome.recentUsers.title': 'Последние обращения',
  'pages.welcome.recentUsers.empty': 'Обращений к чату пока не было',
  'pages.welcome.recentUsers.requests': 'Запросов за период',
  'pages.welcome.recentUsers.channel.text': 'Текст',
  'pages.welcome.recentUsers.channel.voice': 'Голос',
  'pages.welcome.title': 'Сводка',
  'pages.welcome.description':
    'Сводка по чату: пользователи, время отклика, текстовые и голосовые запросы, последние обращения.',
  'pages.school.title': 'Школа',
  'pages.school.description':
    'Последовательно выберите страну, регион, город, школу, роль и профиль. Выбор сохранится и будет отправляться в чат параметрами.',
  'pages.school.country': 'Страна',
  'pages.school.region': 'Регион',
  'pages.school.city': 'Город',
  'pages.school.school': 'Школа',
  'pages.school.role': 'Роль',
  'pages.school.class': 'Класс',
  'pages.school.employee': 'Сотрудник',
  'pages.school.student': 'Ученик',
  'pages.school.subject': 'Предмет',
  'pages.school.profile': 'Пользователь',
  'pages.school.placeholder': 'Выберите',
  'pages.school.saved': 'Сохранённый выбор',
  'pages.school.savedHint': 'Этот JSON отправляется в чат вместе с вопросом.',
  'pages.school.empty': 'Ничего не выбрано',
  'pages.school.clear': 'Очистить выбор',
  'pages.school.loadError': 'Не удалось загрузить данные школы',
  'pages.school.role.teacher': 'учитель',
  'pages.school.role.student': 'ученик',
  'pages.school.role.parent': 'родитель',
  'pages.school.role.director': 'директор',
  'pages.school.role.class_teacher': 'классный руководитель',
  'pages.school.role.employee': 'сотрудник',
  'pages.welcome.chatInfo.title': 'Подключение чата',
  'pages.welcome.chatInfo':
    'Вы можете легко добавить этот чат на любую другую страницу, просто импортировав компонент ChatDialog.',
  'pages.welcome.chatFeatures.title': 'Функциональность чата',
  'pages.welcome.chatFeatures.textMessages': 'Отправка текстовых сообщений',
  'pages.welcome.chatFeatures.fileUpload': 'Загрузка файлов',
  'pages.welcome.chatFeatures.messageHistory': 'История сообщений',
  'pages.welcome.chatFeatures.autoScroll': 'Автоматическая прокрутка к последнему сообщению',
  'pages.welcome.chatFeatures.modalWindow': 'Модальное окно для удобного взаимодействия',
  'pages.welcome.organization.title': 'Текущая организация',
  'pages.welcome.organization.select': 'Выберите организацию',
  'pages.welcome.organization.empty':
    'Нет доступных организаций или контекстов для этого пользователя',
  'pages.welcome.organization.fallback': 'Организация',
  'pages.welcome.organization.loadFailed': 'Не удалось загрузить контексты организации',
  'pages.welcome.organization.switchSuccess': 'Контекст организации успешно переключён',
  'pages.welcome.organization.switchFailed': 'Не удалось переключить контекст организации',
  // List page
  'pages.list.uploadFiles': 'Загрузить файлы',
  'pages.list.uploading': 'Загрузка...',
  'pages.list.uploadedFiles': 'Загруженные файлы',
  'pages.list.download': 'Скачать',
  // Управление пользователями
  'pages.users.loading': 'Загрузка данных пользователя...',
  'pages.users.fetchError': 'Не удалось загрузить пользователей',
  'pages.users.noUserData': 'Данные пользователя недоступны',
  'pages.users.userInformation': 'Информация о пользователе',
  'pages.users.accountCreated': 'Аккаунт создан',
  'pages.users.lastUpdated': 'Последнее обновление',
  'pages.users.title': 'Управление пользователями',
  'pages.users.welcome':
    'Добро пожаловать, {name}! Управляйте пользователями и настройками системы.',
  'pages.users.status': 'Статус',
  'pages.users.actions': 'Действия',
  'pages.users.user': 'Пользователи',
  'pages.users.active': 'Активен',
  'pages.users.inactive': 'Неактивен',
  'pages.users.editUser': 'Редактировать пользователя',
  'pages.users.updateUser': 'Обновить пользователя (по id)',
  'pages.users.deleteUser': 'Удалить пользователя (по id)',
  'pages.users.userIdRequired': 'Введите идентификатор пользователя',
  'pages.users.userIdPlaceholder': 'Введите идентификатор пользователя',
  'pages.users.deleteConfirm': 'Вы уверены, что хотите удалить этого пользователя?',
  'pages.users.passwordPlaceholder': 'Оставьте пустым, чтобы сохранить текущий пароль',
  'pages.users.emailPlaceholder': 'Введите электронную почту',
  'pages.users.emailRequired': 'Пожалуйста, введите электронную почту',
  'pages.users.emailInvalid': 'Неверный формат электронной почты',
  'pages.users.nameRequired': 'Пожалуйста, введите имя',
  'pages.users.roleRequired': 'Пожалуйста, выберите роль',
  'pages.users.createNotImplemented': 'Функция создания еще не реализована',
  'pages.users.totalUsers': 'Всего пользователей',
  'pages.users.statsError': 'Ошибка при загрузке статистики',
  'pages.users.noMore': 'Больше пользователей для загрузки нет',
  'pages.users.joined': 'Присоединился',
  'pages.usersCards.title': 'Пользователи (Карточки)',
  'pages.usersCards.welcome':
    'Добро пожаловать, {name}! Просматривайте пользователей в карточном виде.',
  'pages.usersCards.totalUsers': 'Всего пользователей',
  'pages.usersCards.statsError': 'Ошибка при загрузке статистики пользователей',
  'pages.usersCards.fetchError': 'Не удалось загрузить пользователей',
  'pages.usersCards.loading': 'Загрузка пользователей...',
  'pages.usersCards.noMore': 'Больше пользователей для загрузки нет',
  'pages.usersCards.empty': 'Пользователи не найдены',

  // Управление ролями
  'pages.roles.title': 'Управление ролями',
  'pages.roles.role': 'Роли',
  'pages.roles.actions': 'Действия',
  'pages.roles.createRole': 'Создать роль',
  'pages.roles.editRole': 'Редактировать роль',
  'pages.roles.updateRole': 'Обновить роль (по id)',
  'pages.roles.deleteRole': 'Удалить роль (по id)',
  'pages.roles.roleIdRequired': 'Введите идентификатор роли',
  'pages.roles.roleIdPlaceholder': 'Введите идентификатор роли',
  'pages.roles.deleteConfirm': 'Вы уверены, что хотите удалить эту роль?',
  'pages.roles.namePlaceholder': 'Введите название роли',
  'pages.roles.slugPlaceholder': 'Введите обозначение роли (например, admin, user)',
  'pages.roles.nameRequired': 'Пожалуйста, введите название роли',
  'pages.roles.slugRequired': 'Пожалуйста, введите обозначение роли',
  'pages.roles.admin': 'Администратор',
  'pages.roles.user': 'Пользователь',

  // Управление типами субъектов
  'pages.subjectTypes.title': 'Управление типами субъектов',
  'pages.subjectTypes.actions': 'Действия',
  'pages.subjectTypes.createSubjectType': 'Создать тип субъекта',
  'pages.subjects.createSubject': 'Создать субъект',
  'pages.searchTable.requiredField': 'Обязательное поле',
  'pages.subjectTypes.updateSubjectType': 'Обновить тип субъекта (по subject_type_id)',
  'pages.subjectTypes.editSubjectType': 'Редактировать тип субъекта',
  'pages.subjectTypes.subjectTypeIdRequired': 'Введите идентификатор типа субъекта',
  'pages.subjectTypes.subjectTypeIdPlaceholder': 'Введите идентификатор типа субъекта',
  'pages.subjectTypes.subjectTypeIdDeletePlaceholder':
    'Введите идентификатор типа субъекта для удаления',
  'pages.subjectTypes.deleteSubjectType': 'Удалить тип субъекта (по subject_type_id)',
  'pages.subjectTypes.deleteConfirm': 'Вы уверены, что хотите удалить этот тип субъекта?',
  'pages.subjectTypes.namePlaceholder': 'Введите название типа субъекта',
  'pages.subjectTypes.slugPlaceholder': 'Введите обозначение типа субъекта',
  'pages.subjectTypes.nameRequired': 'Пожалуйста, введите название типа субъекта',
  'pages.subjectTypes.slugRequired': 'Пожалуйста, введите обозначение типа субъекта',

  // Управление организациями
  'pages.organizations.title': 'Управление организациями',
  'pages.organizations.organizationIdRequired': 'Введите идентификатор субъекта',
  'pages.organizations.organizationIdPlaceholder': 'Введите идентификатор субъекта',
  'pages.organizations.organizationIdDeletePlaceholder':
    'Введите идентификатор субъекта для удаления',
  'pages.organizations.actions': 'Действия',
  'pages.organizations.createOrganization': 'Создать организацию',
  'pages.organizations.updateOrganization': 'Обновить организацию',
  'pages.organizations.editOrganization': 'Редактировать организацию',
  'pages.organizations.deleteOrganization': 'Удалить организацию',
  'pages.organizations.deleteConfirm': 'Вы уверены, что хотите удалить эту организацию?',
  'pages.organizations.loadError':
    'Не удалось загрузить организации: ошибка сервера (поле organization.type должно быть объектом, а не UUID).',
  'pages.organizations.detailsPlaceholder': '{"key":"value"}',
  'pages.organizations.detailsRequired': 'Пожалуйста, укажите details в формате JSON',

  // Общие действия в таблицах
  'pages.searchTable.new': 'Добавить',
  'pages.searchTable.edit': 'Изменить',
  'pages.searchTable.delete': 'Удалить',
  'pages.searchTable.reset': 'Сбросить',
  'pages.searchTable.query': 'Поиск',
  'pages.searchTable.yes': 'Да',
  'pages.searchTable.no': 'Нет',
  'pages.searchTable.ok': 'ОК',
  'pages.searchTable.cancel': 'Отмена',
  'pages.searchTable.createSuccess': 'Успешно создано',
  'pages.searchTable.createError': 'Ошибка при создании',
  'pages.searchTable.updateSuccess': 'Успешно обновлено',
  'pages.searchTable.updateError': 'Ошибка при обновлении',
  'pages.searchTable.deleteSuccess': 'Успешно удалено',
  'pages.searchTable.deleteError': 'Ошибка при удалении',
  'pages.searchTable.okWithCount': 'ОК ({count})',
  'pages.searchTable.totalRange': '{start}-{end} из {total} записей',
  'pages.searchTable.deleteInputRequired': 'Введите {field}',
  'pages.searchTable.deleteInputPlaceholder': 'Введите идентификатор для удаления',

  // Placeholders
  'pages.searchTable.inputPlaceholder': 'Пожалуйста, введите',
  'pages.searchTable.selectPlaceholder': 'Пожалуйста, выберите',

  // @generated entity-pages
  'pages.aiModel.createAiModel': 'Создать модель ИИ',
  'pages.application.createApplication': 'Создать приложение',
  'pages.brokerEvent.createBrokerEvent': 'Создать событие брокера',
  'pages.communication.createCommunication': 'Создать коммуникация',
  'pages.communicationDetail.createCommunicationDetail': 'Создать деталь коммуникации',
  'pages.communicationFolder.createCommunicationFolder': 'Создать папка коммуникации',
  'pages.communicationHistory.createCommunicationHistory': 'Создать история коммуникации',
  'pages.communicationPermission.createCommunicationPermission': 'Создать разрешение коммуникации',
  'pages.communicationStrategy.createCommunicationStrategy': 'Создать стратегия коммуникации',
  'pages.communicationSubject.createCommunicationSubject': 'Создать субъект коммуникации',
  'pages.communicationVersion.createCommunicationVersion': 'Создать версия коммуникации',
  'pages.communicationView.createCommunicationView': 'Создать представление коммуникации',
  'pages.contextClassifier.createContext': 'Создать классификатор контекста',
  'pages.contextData.createContextData': 'Создать элемент данных контекста',
  'pages.contextPipeline.createContextPipeline': 'Создать конвейер контекста',
  'pages.contextStorage.createContextStorage': 'Создать хранилище контекста',
  'pages.dataPipeline.createDataPipeline': 'Создать конвейер данных',
  'pages.dataPipelineDetail.createDataPipelineDetail': 'Создать детализация конвейера данных',
  'pages.dependentVersionService.createDependentVersionService':
    'Создать зависимость версии сервиса',
  'pages.detailScheduler.createDetailScheduler': 'Создать элемент выполнения планировщика',
  'pages.division.createDivision': 'Создать подразделение',
  'pages.groupContextClassifier.createGroupContextClassifiers':
    'Создать группу классификаторов контекста',
  'pages.historyRunningPipeline.createHistoryRunningPipeline': 'Создать история запуска конвейера',
  'pages.historyRunningStreamPipeline.createHistoryRunningStreamPipeline':
    'Создать история потокового конвейера',
  'pages.individual.createIndividual': 'Создать физическое лицо',
  'pages.injectionVersionService.createInjectionVersionService': 'Создать инъекцию версии сервиса',
  'pages.organization.createOrganization': 'Создать организацию',
  'pages.organizationPosition.createOrganizationPosition': 'Создать позиция организации',
  'pages.organizationStructure.createOrganizationStructure': 'Создать организационная структура',
  'pages.organizationStructurePermission.createOrganizationStructurePermissions':
    'Создать доступ к оргструктуре',
  'pages.permission.createPermission': 'Создать разрешение (доступ)',
  'pages.pipeline.createPipeline': 'Создать конвейер',
  'pages.providerContext.createProviderContext': 'Создать контекст провайдера',
  'pages.providerContextClassifier.createProviderContextClassifiers':
    'Создать классификатор контекста провайдера',
  'pages.resultContextClassifier.createResultContextClassifiers':
    'Создать итоговый классификатор контекста',
  'pages.resultScheduler.createResultScheduler': 'Создать результат планировщика',
  'pages.role.createRole': 'Создать роль',
  'pages.running.createRunning': 'Создать тип выполнения',
  'pages.scheduler.createScheduler': 'Создать планировщик',
  'pages.schemaPipeline.createSchemaPipeline': 'Создать схему конвейера',
  'pages.service.createService': 'Создать сервис',
  'pages.serviceBuild.createBuildServiceVersionResponse': 'Создать service Build',
  'pages.serviceEvent.createServiceEvent': 'Создать событие сервиса',
  'pages.serviceParams.createServiceParams': 'Создать параметры сервиса',
  'pages.serviceRun.createRunServiceVersionResponse': 'Создать service Run',
  'pages.serviceType.createServiceType': 'Создать тип сервиса',
  'pages.serviceVersion.createServiceVersion': 'Создать версия сервиса',
  'pages.serviceVersionBuild.createBuildServiceVersionResponse': 'Создать service Version Build',
  'pages.serviceVersionRun.createRunServiceVersionResponse': 'Создать service Version Run',
  'pages.shareContextStorage.createShareContextStorage': 'Создать общее хранилище контекста',
  'pages.subject.createSubject': 'Создать субъект',
  'pages.subjects.createSubject': 'Создать subjects',
  'pages.subjectType.createSubjectType': 'Создать тип субъекта',
  'pages.subjectTypes.createSubjectType': 'Создать тип субъекта',
  'pages.testPipeline.createTestPipeline': 'Создать тестовый конвейер',
  'pages.testResultPipeline.createTestResultPipeline': 'Создать результат тестового конвейера',
  'pages.tuneModel.createTuneModel': 'Создать задача дообучения',
  'pages.tuneModelResult.createTuneModelResult': 'Создать результат дообучения модели',
  'pages.typeProviderContext.createTypeProviderContexts': 'Создать тип контекста провайдера',
  'pages.typeSubjectCommunication.createTypeSubjectCommunication':
    'Создать тип субъекта коммуникации',
  'pages.user.createUser': 'Создать пользователь',
  'pages.userContext.createUserContextItem': 'Создать контекст пользователя',
  'pages.userOrganizationStructure.createUserOrganizationStructure':
    'Создать пользователь в оргструктуре',
  'pages.versionProviderContext.createVersionProviderContext':
    'Создать версия контекста провайдера',
};
